module.exports = __webpack_public_path__ + "img/KBZ-Bank.fee4e78a.png";